
import { useAppSelector } from '../../../store/hooks';


type PropsType = {
  handleMemberTypeClick: (data: any) => void;
  memberType: string;
};

const ListSidebar = (props: PropsType) => {
  const { memberList } = useAppSelector((state) => state.member);
  return (
    <div className="md:w-[200px] w-full">
      <ul className="flex md:flex-col flex-row gap-3 whitespace-nowrap overflow-x-auto">
        <li>
          <button
            type="button"
            //   :className="openTab === 1 ? activeClasses : inactiveClasses"
            className={`bg-green-500 p-2 w-full rounded-md text-white md:text-base text-sm font-normal  ${
              props.memberType === ""
                ? "bg-red-500 hover:bg-red-500"
                : "hover:bg-red-500"
            }`}
            onClick={() => {
              props.handleMemberTypeClick("");
            }}
          >
            Total MP({memberList?.results?.total})
          </button>
        </li>
        <li>
          <button
            type="button"
            onClick={() => {
              props.handleMemberTypeClick("REGULAR");
            }}
            //   :className="openTab === 2 ? activeClasses : inactiveClasses"
            className={`bg-green-500 p-2 w-full rounded-md text-white md:text-base text-sm font-normal  ${
              props.memberType === "REGULAR"
                ? "bg-red-500 hover:bg-red-500"
                : "hover:bg-red-500"
            }`}
          >
            Regular MP({memberList?.results?.regular_member_count})
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.handleMemberTypeClick("SHADOW");
            }}
            type="button"
            //   :className="openTab === 3 ? activeClasses : inactiveClasses"
            className={`bg-green-500 p-2 w-full rounded-md text-white md:text-base text-sm font-normal  ${
              props.memberType === "SHADOW"
                ? "bg-red-500 hover:bg-red-500"
                : "hover:bg-red-500"
            }`}
          >
            Shadow MP({memberList?.results?.shadow_member_count})
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.handleMemberTypeClick("PROSPECTIVE");
            }}
            type="button"
            //   :className="openTab === 4 ? activeClasses : inactiveClasses"
            className={`bg-green-500 p-2 w-full rounded-md text-white md:text-base text-sm font-normal  ${
              props.memberType === "PROSPECTIVE"
                ? "bg-red-500 hover:bg-red-500"
                : "hover:bg-red-500"
            }`}
          >
            Prospective MP({memberList?.results?.prospective_member_count})
          </button>
        </li>
      </ul>
    </div>
  );
}

export default ListSidebar